import React, { ReactNode } from 'react';
import './PopupComponent.css';
import Spinner from '../components/custom/Spinner';

interface PopupComponentProps {
  title?: string;
  onClose: () => void;
  onConfirm?: () => void;
  children: ReactNode;
  isConfirm: boolean;
}

const PopupComponent: React.FC<PopupComponentProps> = ({
  title,
  onClose,
  onConfirm,
  children,
  isConfirm
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-btn" onClick={onClose}>×</button>
        {title && <h2>{title}</h2>}

        <div className="popup-content">
          {children}
        </div>

        {onConfirm && (
          <button className="confirm-btn" onClick={onConfirm} disabled={isConfirm}>
            {isConfirm && <Spinner />}
            Confirm
          </button>
        )}
      </div>
    </div>
  );
};

export default PopupComponent;
